module.exports = __webpack_public_path__ + "img/8.6c71977e.png";